// @flow

export const SAVE_COUNTRY_CODES: 'save/country/codes' = 'save/country/codes';

export type Action =
  | {
    type: typeof SAVE_COUNTRY_CODES,
    codes: {},
  }
  ;
